export default __webpack_public_path__ + "static/media/setting.220a34de.svg";